// A template can carry a field whose per-index settings arrays were never saved, so every read
// here has to tolerate a missing key rather than throw and kill the whole layout preview.
function valueAt(templateSettings, key, index) {
  const values = templateSettings ? templateSettings[key] : null;

  return Array.isArray(values) ? values[index] : undefined;
}

export function settingNumber(templateSettings, key, index, fallback = 0) {
  const parsed = parseFloat(valueAt(templateSettings, key, index));

  return Number.isFinite(parsed) ? parsed : fallback;
}

export function settingFlag(templateSettings, key, index) {
  return Boolean(valueAt(templateSettings, key, index));
}

export function settingRaw(templateSettings, key, index) {
  return valueAt(templateSettings, key, index);
}
